export default {"src":"/_next/static/media/logo-chevron.21cf4d4b.svg","height":9,"width":5,"blurWidth":0,"blurHeight":0};